import { AttributeDataType, IServiceMetadata, IServiceStage, ServiceRequestStatus } from '../models'
import { CollapsiblePanel, Spinner } from '../../../../widgets'
import { Form, Formik } from 'formik'
import React, { FC, useEffect } from 'react'

import { KTSVG } from '../../../../../helpers'
import { ServiceAttributeWrapper } from '../service-attribute/ServiceAttributeWrapper'
import { ServiceReqHelper } from '../helpers/helper'
import { ServiceRequestActions } from '../service-request-actions/ServiceRequestActions'
import { ServiceRequestApproval } from '../service-request-actions/ServiceRequestApproval'
import clsx from 'clsx'
import { useSearchParams } from 'react-router-dom'
import { useServiceRequestContext } from './ServiceRequestContext'
import { useState } from 'react'

interface IViewServiceRequestProps {
    metadata: IServiceMetadata,
    hideHeader?: boolean,
    hideTitle?: boolean,
    enableSubmit?: boolean
    enableApproval?: boolean,
    documentsOnly: boolean,
    values: any,
    entity?: string,
    relativePath?: string,
    enableResend?: boolean,
    isSendingForApproval?: boolean,
    onCancel: (requestId: string) => void
    onReOpen: (requestId: string) => void
    onExtended: (requestId: string, extendGPId: string) => void
}

export const ViewServiceRequest: FC<IViewServiceRequestProps> = ({
    metadata,
    enableSubmit,
    enableApproval,
    values,
    entity,
    relativePath,
    hideHeader,
    hideTitle,
    documentsOnly,
    enableResend,
    isSendingForApproval,
    onCancel,
    onReOpen,
    onExtended,
}) => {
    const { result, updateServiceRequest } = useServiceRequestContext()
    const [stages, setStages] = useState<IServiceStage[]>([])
    const serviceRequest = result?.serviceRequest
    const [searchParams] = useSearchParams();

    const hasValidAuthToken = () => {
        const approvalToken: string | undefined = searchParams.get("reqId") || undefined
        return serviceRequest?.approvalToken && serviceRequest?.approvalToken === approvalToken
    }

    useEffect(() => {
        const stages = metadata
            .stages
            .sort((a, b) => (a.stageNumber || 0) - (b.stageNumber || 0))

        setStages(stages)

        // eslint-disable-next-line
    }, [])

    const handleSubmit = async () => {
        if (serviceRequest?.statusCode !== ServiceRequestStatus.Rejected)
            return;

        const updatedRequest = {
            ...serviceRequest,
            statusCode: ServiceRequestStatus.Submitted
        };

        await updateServiceRequest(updatedRequest);
    };

    const getStages = () => {
        let stages2 = stages;
        if (documentsOnly) {
            let docStages: IServiceStage[] = [];
            for (var i = 0; i < stages.length; i++) {
                const stage = stages[i];
                var items = metadata.serviceAttributes.filter(p => p.required && p.serviceStageId === stage.id && metadata.attributes.find(p2 => p2.id === p.attributeId)?.datatype === AttributeDataType.DocumentChecklist)
                if (items && items.length !== 0) {
                    docStages.push(stage)
                }
            }

            stages2 = docStages;
        }

        return <>
            {stages2.map((stage, index) => <React.Fragment key={stage.id}>
                <CollapsiblePanel
                    eventKey={stage.id}
                    header={stage.name}>
                    <div className={clsx('row g-2')}>
                        {metadata.serviceAttributes
                            .filter(p => p.serviceStageId === stage.id)
                            .sort((a, b) => (a.order || 0) - (b.order || 0))
                            .map(attr => <React.Fragment key={attr.id}>
                                <ServiceAttributeWrapper
                                    metadata={metadata}
                                    attribute={attr}
                                    value={values[attr.attributeId]}
                                    entity={entity}
                                    entityId={serviceRequest?.id}
                                    relativePath={relativePath}
                                    documentsOnly={documentsOnly}
                                />
                            </React.Fragment>)}
                    </div>
                </CollapsiblePanel>
            </React.Fragment>)}
        </>
    }

    const requestHeader = () => {
        if (hideHeader === true) return <></>

        const { color, backgroundColor } = ServiceReqHelper.getStatusColors(serviceRequest?.statusCode)

        return <>
            <div className='mb-2 d-flex gap-3 text-center'>
                <div className='flex-fill'>
                    {(hideTitle !== true) && <h1 className='text-gray-700 mb-0'>{metadata.service.name}</h1>}
                    {(serviceRequest?.requestNumber) && <div className='d-flex gap-2 justify-content-center'>
                        <div className='fs-7 text-gray-600 fw-bold'>
                            <span>#</span>
                            <span className='text-gray-700 fw-bolder ms-2'>{serviceRequest?.requestNumber}</span>
                        </div>
                        <div className='d-flex flex-column fs-8'>
                            <span className='px-2 fs-7 fw-bold rounded' style={{ backgroundColor: color, color: backgroundColor }}>{ServiceReqHelper.status(serviceRequest?.statusCode)}</span>
                        </div>
                    </div>}
                </div>
            </div>
        </>
    }

    return (
        <>
            <Formik initialValues={{}} onSubmit={handleSubmit}>
                {({ isSubmitting }) => (
                    <Form>
                        <>{requestHeader()}</>
                        <div>
                            {getStages()}
                        </div>
                        {(enableSubmit && serviceRequest?.statusCode === ServiceRequestStatus.Rejected) &&
                            <>
                                <div>
                                    <button type='submit'
                                        className='btn btn-lg btn-primary me-3 float-end'>
                                        <span className='indicator-label'>
                                            {isSubmitting && <Spinner className='me-2' show={isSubmitting} />}
                                            <span>Re-Submit</span>

                                            <KTSVG
                                                path='/media/icons/duotune/arrows/arr064.svg'
                                                className='svg-icon-3 ms-2 me-0'
                                            />
                                        </span>
                                    </button>
                                </div>
                            </>}
                    </Form>
                )}
            </Formik>

            {(enableResend) && <ServiceRequestActions onCancel={onCancel} onReOpen={onReOpen} onExtended={onExtended} isSendingForApproval={isSendingForApproval} />}
            {(enableApproval === true && hasValidAuthToken()) && <ServiceRequestApproval />}
        </>
    )
}